import React from 'react';

import { componentService } from '@core/js/services/component.service';

import { BALANCE_TYPES } from '@interlayer/js/app/components/main/Balance/constants';

export const Balance = React.lazy(() => import(/* webpackChunkName: "user-balance" */ './Balance'));

componentService.registerWebContentComponents({
    BonusBalance: () => <Balance type={BALANCE_TYPES.bonus_balance} />,
    TotalBonusBalance: () => <Balance type={BALANCE_TYPES.total_bonus_balance} />,
    RealGamingBalance: () => <Balance type={BALANCE_TYPES.real_gaming_balance} />,
    TotalFreeSpinsBalance: () => <Balance type={BALANCE_TYPES.free_spin_balance} />,
    WithdrawableBalance: () => <Balance type={BALANCE_TYPES.withdrawable_balance} />,
    CasinoGamingBalance: () => <Balance type={BALANCE_TYPES.casino_gaming_balance} />,
    BonusPendingWinnings: () => <Balance type={BALANCE_TYPES.bonus_pending_winnings} />,
    RingfencedRealBalance: () => <Balance type={BALANCE_TYPES.ringfenced_real_balance} />,
    BrokenGamesRealBalance: () => <Balance type={BALANCE_TYPES.broken_games_real_balance} />,
    CasinoTableRealBalance: () => <Balance type={BALANCE_TYPES.casino_table_real_balance} />,
    BrokenGamesBonusBalance: () => <Balance type={BALANCE_TYPES.broken_games_bonus_balance} />,
    Balance
});
